import { render, staticRenderFns } from "./TableWorker.vue?vue&type=template&id=1368f3c0&scoped=true"
import script from "./TableWorker.vue?vue&type=script&lang=js"
export * from "./TableWorker.vue?vue&type=script&lang=js"
import style0 from "./TableWorker.vue?vue&type=style&index=0&id=1368f3c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1368f3c0",
  null
  
)

export default component.exports